












import { createComponent, computed } from "@vue/composition-api";
import { Button } from "element-ui";

interface Props {
  size: "verySmall" | "small" | "medium" | "large";
  variant:
    | "primary"
    | "success"
    | "warning"
    | "danger"
    | "info"
    | "text"
    | undefined;
  disabled: boolean;
}

const elSizeMap = {
  large: "medium",
  medium: "medium",
  small: "small",
  verySmall: "mini",
};

export default createComponent<Props>({
  components: { Button },
  props: {
    size: { default: "medium" },
    variant: { required: false },
    disabled: { default: false },
  },
  setup(props, ctx) {
    const elSize = computed(() => elSizeMap[props.size]);
    return { elSize };
  },
});
